import * as yup from 'yup';

export const purposeDetailsSchema = yup.object().shape({
  loanPurposeDetails: yup.string().when('loanPurpose', {
    is: 'other',
    then: (schema) => schema.trim().required('benötigt'),
  }),
});
